import type { Ref } from 'vue';
import { ref } from 'vue';

export interface IModalPageWrapperComposable {
  showPageDialog: Ref<boolean>;
  openPageDialog(): void;
  closePageDialog(): void;
}

export default function useModalPageWrapper(defaultVisibleValue = true): IModalPageWrapperComposable {
  const showPageDialog = ref(defaultVisibleValue);

  function openPageDialog(): void {
    showPageDialog.value = true;
  }

  function closePageDialog(): void {
    showPageDialog.value = false;
  }

  return {
    showPageDialog,
    openPageDialog,
    closePageDialog,
  };
}
